import React, { useEffect, useState } from "react";
import { Form, Select, Button, Input, Row, Col, Typography, Table, Tooltip } from "antd";
import { PlusOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import RightSidePreviewWindow from "../../../../modals/PreviewModalForDrawer";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";
interface DoctorData {
  key: string;
  doctorName: string;
  doctorRegistrationId: string;
  doctorQualification: string;
  doctorContact: string;
}

const CareTeamDetails: React.FC<any> = ({
  form,
  handleDeleteDoctorDetails,
  portalData,
  allDocumentList,
  patientDetails
}) => {
  // const [form] = Form.useForm();
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [doctorData, setDoctorData] = useState<DoctorData[]>([]);
  const [isAdded, setIsAdded] = useState(false);
  const [formComplete, setFormComplete] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [previewDocumentUrl, setPreviewDocumentUrl] = useState('');
  const [open, setOpen] = useState(false);
  const { auth } = useSelector((state: RootState) => state);

  const doctorOptions = [{ label: "Other", value: "other" }];

  const qualificationOptions = [
    { label: "M.B.B.S.", value: "M.B.B.S." },
    { label: "M.D.", value: "M.D." },
    { label: "Master of Surgery (M.S.)", value: "Master of Surgery (M.S.)" },
    {
      label: "Doctorate of Medicine (D.M.)",
      value: "Doctorate of Medicine (D.M.)",
    },
    {
      label: "Master of Chirurgiae (M.Ch)",
      value: "Master of Chirurgiae (M.Ch)",
    },
    { label: "DNB", value: "DNB" },
    {
      label: "Master of Dental Surgery (M.D.S.)",
      value: "Master of Dental Surgery (M.D.S.)",
    },
    {
      label: "Diploma in Otorhinolaryngology",
      value: "Diploma in Otorhinolaryngology",
    },
    { label: "Ayush Doctor", value: "Ayush Doctor" },
    {
      label: "Registered Medical Assistant (RMA)",
      value: "Registered Medical Assistant (RMA)",
    },
    {
      label: "Diploma in Child Health (D.C.H)",
      value: "Diploma in Child Health (D.C.H)",
    },
    {
      label: "Bachelor of Dental Surgery",
      value: "Bachelor of Dental Surgery",
    },
  ];

  const selectedDoctor = form.getFieldValue("selectedDoctor");  //Form.useWatch("selectedDoctor", form)

  useEffect(() => {
    if (selectedDoctor) {
      if (selectedDoctor === "other" && !portalData?.casePreAuthCghs?.doctorName) {
        setIsOtherSelected(true);
        form?.setFieldsValue({
          doctorName: undefined,
          doctorRegistrationId: undefined,
          doctorQualification: undefined,
          doctorContact: undefined,
        });
        setFormComplete(false);
      }
    }
  }, [selectedDoctor]);

  const handleDoctorSelect = (value: string) => {
    const other = value === "other";
    setIsOtherSelected(other);

    if (other) {
      form?.setFieldsValue({
        doctorName: undefined,
        doctorRegistrationId: undefined,
        doctorQualification: undefined,
        doctorContact: undefined,
      });
      setFormComplete(false);
    } else {
      form?.setFieldsValue({
        doctorName: undefined,
        doctorRegistrationId: undefined,
        doctorQualification: undefined,
        doctorContact: undefined,
      });
      setFormComplete(false);
    }
  };

  const handleFormChange = (_changed: any, allValues?: any) => {
    const values = allValues ?? form?.getFieldsValue?.();
    const name = values?.doctorName;
    const reg = values?.doctorRegistrationId;
    const qual = values?.doctorQualification;
    const contact = values?.doctorContact;
    const contactVal = contact == null ? "" : String(contact);
    const isComplete = !!name && !!reg && !!qual && contactVal.length === 10;
    setFormComplete(isComplete);
  };

  const handleAddDoctor = async () => {
    try {
      await form?.validateFields?.([
        "doctorName",
        "doctorRegistrationId",
        "doctorQualification",
        "doctorContact",
      ]);

      const values = form?.getFieldsValue?.();
      const newDoctor: any = {
        key: Date.now().toString(),
        doctorName: values.doctorName,
        doctorRegistrationId: values.doctorRegistrationId,
        doctorQualification: values.doctorQualification,
        doctorContact: values.doctorContact,
      };

      setDoctorData([newDoctor]);
      setIsAdded(true);
      setFormComplete(false);
    } catch {}
  };

  const handleDeleteDoctor = (key: string) => {
    setDoctorData([]);
    setIsAdded(false);
    form?.setFieldsValue({
      doctorName: undefined,
      doctorRegistrationId: undefined,
      doctorQualification: undefined,
      doctorContact: undefined,
      selectedDoctor: undefined,
    });
    setIsOtherSelected(true);
    setFormComplete(false);
  };

  const columns = [
    {
      title: "Doctor Name",
      dataIndex: "doctorName",
      key: "doctorName",
    },
    {
      title: "Registration ID",
      dataIndex: "doctorRegistrationId",
      key: "doctorRegistrationId",
    },
    {
      title: "Qualification",
      dataIndex: "doctorQualification",
      key: "doctorQualification",
    },
    {
      title: "Contact",
      dataIndex: "doctorContact",
      key: "doctorContact",
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: DoctorData) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          disabled={portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted}
          onClick={() => {
            if (portalData?.id) {
              handleDeleteDoctorDetails();
            }
            handleDeleteDoctor(record.key);
          }}
        />
      ),
    },
  ];

  useEffect(() => {
    const doctorValues = form.getFieldsValue([
      "selectedDoctor",
      "doctorName",
      "doctorRegistrationId",
      "doctorQualification",
      "doctorContact",
    ]);

    if (doctorValues.doctorName) {
      setIsOtherSelected(true);
      const newDoctor: DoctorData = {
        key: "1", // Use existing ID if available
        doctorName: doctorValues.doctorName,
        doctorRegistrationId: doctorValues.doctorRegistrationId,
        doctorQualification: doctorValues.doctorQualification,
        doctorContact: doctorValues.doctorContact,
      };
      setDoctorData([newDoctor]);
      setIsAdded(true);
    }
  }, [form]);

  useEffect(() => {
    const selectedDocument = allDocumentList?.["Claim"]?.find(
      (doc: any) => doc?.id === "Consultation_Notes",
    );
    const link = selectedDocument?.data;
    setPreviewDocumentUrl(link);
  }, [allDocumentList]);

  return (
    <div style={{ marginBottom: "24px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
          paddingRight: "50px",
        }}
      >
        <span style={{ textDecoration: "underline" }}>Care Team Details</span>

        {patientDetails?.visitInfoResponse?.visitType?.toUpperCase() === "OP" && 
        (auth?.role?.role == "Mid Office Role" || auth?.role?.role == "BO_STAFF") && (
          <Tooltip title=" Consultation notes preview">
            <EyeOutlined
              style={{
                fontSize: "18px",
                cursor: previewDocumentUrl ? "pointer" : "not-allowed",
                color: previewDocumentUrl ? undefined : "#595959",
                opacity: previewDocumentUrl ? 1 : 0.5,
              }}
              onClick={() => {
                if (!previewDocumentUrl) return;
                
                setPreviewDocument(true);
              }}
            />
          </Tooltip>
        )}
      </div>

      <Form form={form} layout="vertical" onValuesChange={handleFormChange}>
        <Form.Item
          label="Select Doctor"
          name="selectedDoctor"
          rules={[{ required: true, message: "Please select an option" }]}
        >
          <Select
            options={doctorOptions}
            style={{ width: "100%" }}
            onChange={handleDoctorSelect}
            placeholder="Select a doctor"
            disabled={isAdded}
          />
        </Form.Item>

        {isOtherSelected && !isAdded ? (
          <>
            <Row gutter={16} style={{ marginBottom: 16 }}>
              <Col span={6}>
                <Form.Item
                  label="Doctor Name"
                  name="doctorName"
                  rules={[
                    { required: true, message: "Please enter doctor name" },
                    { whitespace: true, message: "Name cannot be empty" },
                  ]}
                >
                  <Input placeholder="Doctor Name" />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  label="Registration ID"
                  name="doctorRegistrationId"
                  rules={[
                    { required: true, message: "Please enter registration ID" },
                    {
                      whitespace: true,
                      message: "Registration ID cannot be empty",
                    },
                  ]}
                >
                  <Input placeholder="Registration ID" />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  label="Qualification"
                  name="doctorQualification"
                  rules={[
                    { required: true, message: "Please select qualification" },
                  ]}
                >
                  <Select
                    options={qualificationOptions}
                    placeholder="Select qualification"
                  />
                </Form.Item>
              </Col>

              <Col span={6}>
                <Form.Item
                  label="Contact Number"
                  name="doctorContact"
                  rules={[
                    { required: true, message: "Please enter contact number" },
                    {
                      pattern: /^[0-9]{10}$/,
                      message: "Please enter valid 10-digit number",
                    },
                  ]}
                >
                  <Input placeholder="Contact Number" maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

            <Button
              type="primary"
              onClick={handleAddDoctor}
              icon={<PlusOutlined />}
              disabled={!formComplete}
              style={{ marginBottom: 20 }}
            >
              Add Doctor
            </Button>
          </>
        ) : (
          <></>
        )}

        {doctorData.length > 0 && (
          <Table
            columns={columns}
            dataSource={doctorData}
            pagination={false}
            bordered
            rowKey="key"
            className="amount-incentive-table"
          />
        )}
      </Form>

      <RightSidePreviewWindow
        key={previewDocumentUrl}
        documentUrl={previewDocumentUrl}
        handleCancel={() => setPreviewDocument(false)}
        open={previewDocument}
        setOpen={setOpen}
      />

    </div>
  );
};

export default CareTeamDetails;
